import React, { useState, useEffect } from "react";
import {
    IonRadioGroup,
    IonRadio,
    IonItem,
    IonLabel,
} from "@ionic/react";

// Define question types
type QuestionType = "trueFalse" | "multipleChoice";

interface MultipleChoiceQuestion {
    question: string;
    options: string[];
    correct: string;
}

interface TrueFalseQuestion {
    question: string;
    correct: boolean;
}


const Prepositions: React.FC = () => {
    const [currentQuestion, setCurrentQuestion] = useState<MultipleChoiceQuestion | TrueFalseQuestion | null>(null);
    const [selectedOption, setSelectedOption] = useState<string | boolean | null>(null);
    const [isCorrect, setIsCorrect] = useState(false);
    const [showImage, setShowImage] = useState(false);

    const [questionBank, setQuestionBank] = useState<Record<QuestionType, (MultipleChoiceQuestion | TrueFalseQuestion)[]>>({
        multipleChoice: [],
        trueFalse: []
    });

    const fetchQuestions = async () => {
        try {
            let multipleChoiceQuestion: MultipleChoiceQuestion[] = [];
            let trueFalseQuestion: TrueFalseQuestion[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {

                const response = await fetch(process.env.REACT_APP_API_URL + 'PrepositionsClassTwoTrueFalse.json');
                trueFalseQuestion = await response.json();

                const response1 = await fetch(process.env.REACT_APP_API_URL + 'PrepositionsClassTwoMultipleChoice.json');
                multipleChoiceQuestion = await response1.json();

            } else {
                const module = await import('../../../datas/PrepositionsClassTwoTrueFalse.json');
                trueFalseQuestion = module.default;

                const module1 = await import('../../../datas/PrepositionsClassTwoMultipleChoice.json');
                multipleChoiceQuestion = module1.default;
            }
            setQuestionBank({
                multipleChoice: multipleChoiceQuestion,
                trueFalse: trueFalseQuestion
            });
        } catch (error) {
            console.error("Error loading questions:", error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class Two - English - Preposition"; // Set page title
    }, []);

    useEffect(() => {
        if (questionBank.multipleChoice.length || questionBank.trueFalse.length) {
            getRandomQuestion();
        }
    }, [questionBank]);

    const getRandomQuestion = () => {
        const questionTypes = Object.keys(questionBank) as QuestionType[];
        const randomType = questionTypes[Math.floor(Math.random() * questionTypes.length)];
        const randomQuestion = questionBank[randomType][Math.floor(Math.random() * questionBank[randomType].length)];
        setCurrentQuestion(randomQuestion);
        setSelectedOption(null);
    };

    const handleAnswerSubmit = (option: any) => {
        setSelectedOption(option);
        if (!currentQuestion) return;

        if ("correct" in currentQuestion) {
            if (option === currentQuestion.correct) {
                showNextQuestion();
                setIsCorrect(true);
            }
        }
    };

    const showNextQuestion = () => {
        setShowImage(true);
        setTimeout(() => {
            setShowImage(false);
            setSelectedOption(null);
            getRandomQuestion();
            setIsCorrect(false)
        }, 5000);
    }

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter fillPreposition additionWord">
                        {currentQuestion ? (
                            <>
                                <h3 className="mb-3">{currentQuestion.question}</h3>

                                {"options" in currentQuestion ? (
                                    // Handle multiple-choice or identify odd one out question
                                    typeof currentQuestion.options[0] != "object" ? (
                                        <IonRadioGroup onIonChange={(e) => handleAnswerSubmit(e.detail.value)}>
                                            {(currentQuestion as MultipleChoiceQuestion).options.map((option, index) => (
                                                <IonItem
                                                    className={`grid-item ${selectedOption === option
                                                        ? isCorrect === true
                                                            ? "correct"
                                                            : "errorItems"
                                                        : ""
                                                        }`}
                                                    key={index}>
                                                    <IonRadio slot="start" value={option} />
                                                    <IonLabel>{option}</IonLabel>
                                                </IonItem>
                                            ))}
                                        </IonRadioGroup>
                                    ) : (
                                            // Handle picture question
                                            <></>
                                        
                                    )
                                ) :
                                    <>
                                        <IonRadioGroup onIonChange={(e) => handleAnswerSubmit(e.detail.value!)}>
                                            <IonItem
                                                className={`grid-item ${selectedOption === true
                                                    ? isCorrect === true
                                                        ? "correct"
                                                        : "errorItems"
                                                    : ""
                                                    }`}>
                                                <IonRadio slot="start" value={true} />
                                                <IonLabel>True</IonLabel>
                                            </IonItem>
                                            <IonItem
                                                className={`grid-item ${selectedOption === false
                                                    ? isCorrect === true
                                                        ? "correct"
                                                        : "errorItems"
                                                    : ""
                                                    }`}>
                                                <IonRadio slot="start" value={false} />
                                                <IonLabel>False</IonLabel>
                                            </IonItem>
                                        </IonRadioGroup>
                                    </>
                                }
                            </>
                        ) : (
                            <p>Loading question...</p>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default Prepositions;